export default (state, { payload: { id } }) => ({
  ...state,
  items: [
    ...state.items.map(item =>
      item.id === id ? { ...item, ...item.indicatives, indicatives: {} } : item
    )
  ]
});
